import { useState } from 'react';
import API from "../services/api";
import { useNavigate } from 'react-router-dom';

function Register() {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      console.log({ name, email, password });
      await API.post("/api/auth/register", {
        name,
        email,
        password
      });

      alert("Registration Successfully");
      navigate("/login");
    } catch (error) {
      console.log(error);
      alert("Registration Failed")
    }
  };
  return (
    <div className="container mt-5">
      <h2>Register</h2>

      <form onSubmit={handleRegister} className="col-md-6">

        <div className="mb-3">
          <label>Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button className="btn btn-success">Register</button>

      </form>
    </div>
  )
}

export default Register;